import { get } from 'lodash';
import i18next from 'i18next';

import {
  PATHS_AVAILABLE_IN_ALL_WORKSPACES,
  HELP_CENTER_FEATURE_NAME,
  REFERRAL_FEATURE_NAME,
} from '@commons/constants/centralConstants';

export const getFeaturesModalColumns = (hasCentralKitchens) => [
  {
    id: 'name',
    name: i18next.t('GENERAL.PAGE'),
    propertyKey: 'name',
    filterType: 'text',
  },
  {
    id: 'module',
    name: i18next.t('GENERAL.MODULE'),
    propertyKey: 'module',
    filterType: 'text',
  },
  {
    id: 'path',
    name: i18next.t('GENERAL.PATH'),
    propertyKey: 'path',
    displayBigger: true,
  },
  {
    id: 'isCentral',
    name: i18next.t('GENERAL.WORKSPACE'),
    propertyKey: 'isCentral',
    baseName: 'isCentral',
    hidden: !hasCentralKitchens,
    excludeFromSearch: true,
    render: (isCentral, feature) => {
      if (isCentral) {
        return i18next.t('GENERAL.CENTRAL');
      }

      const featurePathMainModule = get(feature.path.split('/'), '[1]', '');

      if (
        PATHS_AVAILABLE_IN_ALL_WORKSPACES.includes(featurePathMainModule) ||
        feature.name === HELP_CENTER_FEATURE_NAME ||
        feature.name === REFERRAL_FEATURE_NAME
      ) {
        return i18next.t('GENERAL.COMMON');
      }

      return i18next.t('GENERAL.SALE_POINT');
    },
  },
];

export default { getFeaturesModalColumns };
